export default __webpack_public_path__ + "static/media/appleIcon.a01f9287.svg";